import axios from './../../axios/axios';

import * as actionTypes from '../constants/actionTypes';
import { validateObj } from '../../utils';

const getRenewalTypesStart = () => {
  return {
    type: actionTypes.GET_RENEWAL_TYPES_START,
  };
};

const getRenewalTypesSuccess = (data) => {
  return {
    type: actionTypes.GET_RENEWAL_TYPES_SUCCESS,
    renewalTypes: data,
  };
};

const getRenewalTypesFail = (error) => {
  return {
    type: actionTypes.GET_RENEWAL_TYPES_FAIL,
    error: error,
  };
};

export const getRenewalTypes = () => {
  return (dispatch) => {
    dispatch(getRenewalTypesStart());

    const url = `/types/get-renewal-types`;

    axios
      .get(url)
      .then((response) => dispatch(getRenewalTypesSuccess(response.data)))
      .catch((err) => dispatch(getRenewalTypesFail(err)));
  };
};

const getPolicySearchFilterStatusesStart = () => {
  return {
    type: actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_START,
  };
};

const getPolicySearchFilterStatusesSuccess = (data) => {
  return {
    type: actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_SUCCESS,
    policySearchFilterStatuses: data,
  };
};

const getPolicySearchFilterStatusesFail = (error) => {
  return {
    type: actionTypes.GET_POLICY_SEARCH_FILTER_STATUSES_FAIL,
    error: error,
  };
};

export const getPolicySearchFilterStatuses = () => {
  return (dispatch) => {
    dispatch(getPolicySearchFilterStatusesStart());

    const url = `/types/get-policy-search-filter-statuses`;

    axios
      .get(url)
      .then((response) => dispatch(getPolicySearchFilterStatusesSuccess(response.data)))
      .catch((err) => dispatch(getPolicySearchFilterStatusesFail(err)));
  };
};

const getQuoteSearchFilterStatusesStart = () => {
  return {
    type: actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_START,
  };
};

const getQuoteSearchFilterStatusesSuccess = (data) => {
  return {
    type: actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_SUCCESS,
    quoteSearchFilterStatuses: data,
  };
};

const getQuoteSearchFilterStatusesFail = (error) => {
  return {
    type: actionTypes.GET_QUOTE_SEARCH_FILTER_STATUSES_FAIL,
    error: error,
  };
};

export const getQuoteSearchFilterStatuses = () => {
  return (dispatch) => {
    dispatch(getQuoteSearchFilterStatusesStart());

    const url = `/types/get-quote-search-filter-statuses`;

    axios
      .get(url)
      .then((response) => dispatch(getQuoteSearchFilterStatusesSuccess(response.data)))
      .catch((err) => dispatch(getQuoteSearchFilterStatusesFail(err)));
  };
};

const getPropertyTypesStart = () => {
  return {
    type: actionTypes.GET_PROPERTY_TYPES_START,
  };
};

const getPropertyTypesSuccess = (data) => {
  return {
    type: actionTypes.GET_PROPERTY_TYPES_SUCCESS,
    quoteSearchFilterStatuses: data,
  };
};

const getPropertyTypesFail = (error) => {
  return {
    type: actionTypes.GET_PROPERTY_TYPES_FAIL,
    error: error,
  };
};

export const getPropertyTypes = () => {
  return (dispatch) => {
    dispatch(getPropertyTypesStart());

    const url = `/types/get-property-types`;

    axios
      .get(url)
      .then((response) => dispatch(getPropertyTypesSuccess(response.data)))
      .catch((err) => dispatch(getPropertyTypesFail(err)));
  };
};

const getUsersStart = () => {
  return {
    type: actionTypes.GET_USERS_START,
  };
};

const getUsersSuccess = (data, saveAllTypes) => {
  return {
    type: actionTypes.GET_USERS_SUCCESS,
    users: data,
  };
};

const getUsersFail = (error) => {
  return {
    type: actionTypes.GET_USERS_FAIL,
    error: error,
  };
};

export const getUsers = (searchString) => {
  return (dispatch) => {
    dispatch(getUsersStart());

    const url = `/types/get-users`;

    axios
      .get(url, { params: validateObj({ searchString }) })
      .then((response) => dispatch(getUsersSuccess(response.data)))
      .catch((err) => dispatch(getUsersFail(err)));
  };
};

const getServiceRequestStatusesStart = () => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_STATUSES_START,
  };
};

const getServiceRequestStatusesSuccess = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_STATUSES_SUCCESS,
    serviceRequestStatuses: data,
  };
};

const getServiceRequestStatusesFail = (error) => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_STATUSES_FAIL,
  };
};

export const getServiceRequestStatuses = () => {
  return (dispatch) => {
    dispatch(getServiceRequestStatusesStart());
    const url = `/types/get-service-request-statuses`;

    axios
      .get(url)
      .then((response) => dispatch(getServiceRequestStatusesSuccess(response.data)))
      .catch((err) => dispatch(getServiceRequestStatusesFail(err)));
  };
};

const getAutomobileLiabilityCoverageSectionTypesStart = () => {
  return {
    type: actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_START,
  };
};

const getAutomobileLiabilityCoverageSectionTypesSuccess = (data, saveAllTypes) => {
  return {
    type: actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_SUCCESS,
    data: data,
  };
};

const getAutomobileLiabilityCoverageSectionTypesFail = (error) => {
  return {
    type: actionTypes.SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_FAIL,
    error: error,
  };
};

export const getAutomobileLiabilityCoverageSectionTypes = () => {
  return (dispatch) => {
    dispatch(getAutomobileLiabilityCoverageSectionTypesStart());

    const url = `/types/get-automobile-liability-coverage-section-types`;

    axios
      .get(url)
      .then((response) => {
        dispatch(getAutomobileLiabilityCoverageSectionTypesSuccess(response.data));
      })
      .catch((err) => dispatch(getAutomobileLiabilityCoverageSectionTypesFail(err)));
  };
};
